import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { formsAPI } from '../api/client';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

export default function FormSubmissions() {
  const { projectId } = useParams();
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    formsAPI.getSubmissions(projectId)
      .then((res) => setSubmissions(res.data))
      .catch(() => toast.error('Failed to load submissions'))
      .finally(() => setLoading(false));
  }, [projectId]);

  if (loading) return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
    </div>
  );

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <ClipboardDocumentListIcon className="w-6 h-6 text-purple-600" />
        <h1 className="text-2xl font-bold text-gray-900">Form Submissions ({submissions.length})</h1>
      </div>

      {submissions.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-dashed text-gray-400">
          <p className="text-4xl mb-3">📝</p>
          <p className="font-medium">No form submissions yet</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* List */}
          <div className="space-y-2">
            {submissions.map((s) => (
              <button key={s.id}
                onClick={() => setSelected(s)}
                className={`w-full text-left p-4 rounded-xl border transition-colors ${
                  selected?.id === s.id
                    ? 'border-primary-300 bg-primary-50'
                    : 'border-gray-200 bg-white hover:border-gray-300'
                }`}>
                <p className="font-semibold text-gray-800">{s.candidate_name}</p>
                <p className="text-sm text-gray-500">{s.candidate_email}</p>
                <p className="text-xs text-gray-400 mt-1">
                  Submitted {new Date(s.submitted_at).toLocaleDateString()}
                </p>
              </button>
            ))}
          </div>

          {/* Detail */}
          <div className="lg:col-span-2">
            {selected ? (
              <div className="bg-white rounded-2xl border border-gray-200 p-6">
                <h2 className="font-bold text-gray-900 text-lg mb-1">{selected.candidate_name}</h2>
                <p className="text-sm text-gray-500 mb-4">{selected.candidate_email}</p>
                <hr className="mb-4" />
                <div className="space-y-4">
                  {Object.entries(selected.responses).map(([qId, answer]) => (
                    <div key={qId}>
                      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">
                        Question #{qId}
                      </p>
                      <p className="text-gray-800 bg-gray-50 rounded-lg px-3 py-2 text-sm">
                        {Array.isArray(answer) ? answer.join(', ') : String(answer)}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="h-full flex items-center justify-center text-gray-400">
                <p>Select a submission to view details</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
